import { EditorValue } from "../../../services/api/instances/editorApi/types";

export const getSpaUpdatedValue = (
  value: EditorValue,
  fields: Partial<EditorValue["spa_object"]> = {},
): EditorValue => ({
  spa_object: {
    ...value.spa_object,
    ...fields,
  },
});
